module.exports = __webpack_public_path__ + "img/advisor.dfbde257.svg";